/**
 * 页面通用方法
 * @author dzq
 * 页面上报，默认自动上报，支持手动上报。手动上报时先设置autoPv=false，然后再自行选择上报时机进行statPagePv
 */
import { statPv, statStayBegin, statStayEnd } from "../utils/h5-report";
import { setLastp, setPageName } from "../utils/cntp";

export default {
  data() {
    return {
      /**是否自动上报pv */
      autoPv: true,
      reportData: {
        cntp: "",
        lob: {},
      },
    };
  },

  mounted() {
    setTimeout(() => {
      setPageName(this.reportData.cntp);
      console.log("page stay begin");
      this.autoPv && this.statPagePv();
    }, 400);
  },

  beforeDestroy() {
    console.log("page stay end");
    this.statPageStay();
  },
  methods: {
    /**上报页面pv */
    statPagePv() {
      const { cntp, lob } = this.reportData;
      if (!cntp) {
        return;
      }

      /**设置页面编码 */
      document.body.setAttribute("mg-stat-page", cntp);

      statPv(lob);
      statStayBegin(lob);
    },
    /**上报页面停留 */
    statPageStay() {
      const { cntp } = this.reportData;
      if (!cntp) {
        return;
      }
      console.log("上报页面停留cntp", cntp);

      /** 上报页面停留 */
      statStayEnd();

      setLastp(cntp);
    },
  },
};
